import useGDPR from './use-gdpr';

export { useGDPR };

export default useGDPR;
